<div class="outer-container">

  <lib-title-bar
    [crumbs]="[{ 'label': 'Webhooks' }, { 'label': 'Event History' , 'link': '/dashboard/webhooks/event-history' }, { 'label': pageTitle }]">
  </lib-title-bar>

  <div class="details-container">

    @if (!event) {
      <lib-busy-indicator>
      </lib-busy-indicator>
    }
    @if (event) {
      <div class="details-common-container">
        <lib-text-field label="ID">
          {{ event.id }}
        </lib-text-field>
        <lib-text-field id="eventTypeTextField" label="Event Type">
          {{ event.eventType }}
        </lib-text-field>
        <lib-text-field [label]="'Date (' + LocalTimePoint.formatZ() + ')'">
          @if (event.createdUtc) {
            <lib-date-time-label [singleLine]="true" [dateUtc]="event.createdUtc"></lib-date-time-label>
          }
        </lib-text-field>
      </div>
      <div class="label">
        DETAILS
      </div>
      @if (this.dataSource) {
        <div class="details-custom-container">
          <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
            <!-- This is the tree node template for leaf nodes -->
            <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding>
              <!-- use a disabled button to provide padding for tree leaf -->
              <button mat-icon-button disabled></button>
              {{node.name}}
            </mat-tree-node>
            <!-- This is the tree node template for expandable nodes -->
            <mat-tree-node *matTreeNodeDef="let node;when: hasChild" matTreeNodePadding>
              <button mat-icon-button matTreeNodeToggle
                [attr.aria-label]="'Toggle ' + node.name">
                <i [class]="'far ' + (treeControl.isExpanded(node) ? 'fa-chevron-down' : 'fa-chevron-right')"></i>
              </button>
              {{node.name}}
            </mat-tree-node>
          </mat-tree>
        </div>
      }
      <div class="label">
        @if (eventDeliveriesLoading || eventDeliveries?.length > 0) {
          DELIVERIES
        } @else {
          @if (eventDeliveriesError) {
            ERROR LOADING DELIVERIES
          } @else {
            NO DELIVERIES
          }
        }
      </div>
      @if (eventDeliveriesLoading || eventDeliveries?.length > 0) {
        <div class="events-container">
          <lib-table-base
            #eventDeliveriesTableComponent
            [columnDefs]="eventDeliveriesColumnDefs"
            [rowsData]="eventDeliveries"
            [rowsDataLoading]="eventDeliveriesLoading"
            [rowsDataShowWhileLoading]="true"
            rowsDataEmptyMessage="No Deliveries"
            [pager]="pager"
            (pageChanged)="onPageChanged($event)"
            [sorting]="sorting"
            (sortingChanged)="onSortingChanged($event)">
            <ng-template let-element="element" let-columnId="columnId">
              <app-event-deliveries-table-cell-content
                [columnId]="columnId"
                [element]="element"
                (resend)="onResend($event)">
              </app-event-deliveries-table-cell-content>
            </ng-template>
          </lib-table-base>
        </div>
      }
      <div class="form-buttons-line">
        <lib-action-button
          [kind]="ActionButtonKind.STROKED"
          largeButton
          label="Back"
          (click)="onCancel()">
        </lib-action-button>
      </div>
    }

  </div>

</div>


